<template>
    <div>
        <video ref="videoPlayer" class="video-js vjs-default-skin vjs-big-play-centered"></video>
    </div>
</template>

<script>
import videojs from 'video.js';



export default {
    name: "VideoPlayer",
    props: {
        options: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {            
            player: null,
            playing:false,
            isLesson:false
        }
    },
     mounted() {       
        this.player = videojs(this.$refs.videoPlayer, this.options, function onPlayerReady() {
            // console.log('onPlayerReady', this);
        })
         
    },
    beforeDestroy() {
        if (this.player) {
            this.player.dispose()
        }
    },
    methods:{
        setPlaying(flag){
            this.playing=flag;
        },
        playerClose(){
            this.player.pause();
            this.playing=false;
        },
        getCurrentTime(){
            return this.player.currentTime()
        },
        setIntervalAction(func){
            this.player.setInterval(func, 10000);
        },
        setOnVideoEnd(){
            this.player.on('ended', function () {
                alert('aaaaa')
            });
        }
        
    }
}
</script>
